var map = {
	"./ruoyi_01_古镇时间.wav": "2dec",
	"./ruoyi_02_摆姿势.wav": "bc96",
	"./ruoyi_03_是会转的星星.wav": "b7fe",
	"./ruoyi_04_最高的地方.wav": "bc2c",
	"./ruoyi_05_世界绕着转.wav": "c83c",
	"./ruoyi_06_有点危险.wav": "94b2",
	"./xiaoman_01_时间慢.wav": "5312",
	"./xiaoman_02_拍照.wav": "060f",
	"./xiaoman_03_风景.wav": "4790",
	"./xiaoman_04_摩天轮.wav": "020f",
	"./xiaoman_05_世界中心.wav": "690e",
	"./xiaoman_06_超级好玩.wav": "de03"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8581";